module.exports = __webpack_public_path__ + "img/home-ipad_en.15ab879.jpg";